import httpService from "./http.service";

class MainPageService {
  getMainPageUrl = "/main-page";

  getMainPage = () => {
    return httpService.get(this.getMainPageUrl);
  };
  createMainPage = (model) => {
    return httpService.form("/main-page", model, "createMainPage");
  };
  editMainPage = (id, model) => {
    return httpService.form("/main-page/" + id, model, "editMainPage", {}, "patch");
  };
  udpateSortMainPage = (type, model) => {
    return httpService.patch("/main-page/update-sort/" + type, model);
  };
  deleteMainPage = (id) => {
    return httpService.delete("/main-page/" + id);
  };
}

const mainPageService = new MainPageService();
export default mainPageService;
